import { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';

const Layout = () => {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState('en');

  useEffect(() => {
    const lang = localStorage.getItem('locale');
    if (lang && lang == 'ar') {
      i18n.changeLanguage('ar');
      setCurrentLang('ar');
    } else {
      setCurrentLang('en');
    }
  }, []);

  return (
    <div dir={currentLang == 'ar' ? 'rtl' : 'lrt'}>
      <Toaster
        toastOptions={{
          success: { style: { color: '#ffffff', backgroundColor: '#2EB872' } },
          error: { style: { color: '#ffffff', backgroundColor: '#ff0000' } },
        }}
      />
      <Header />
      <div className="min-h-[calc(100vh-7rem)]">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
